import React from 'react'
import PropTypes from 'prop-types'

import { StyledList, StyledListItem } from 'components/product/styled';

const FuelSurchargeText = ({ data }) => {

  const arrowIcon = 'https://images.prismic.io/privatefly/5e231ef5-4344-48db-8c26-878215f331f5_Arrow-Right.png?auto=compress,format';

  return (
    <StyledList>
      { data.items.map((item) => {
        return (
          <StyledListItem>
            <span><img src={arrowIcon} /></span> 
            {item.main_bullet_point_text}
          </StyledListItem>
        )
       })
      }
    </StyledList>
  )
}

FuelSurchargeText.propTypes = {
  data: PropTypes.object,
}

export default FuelSurchargeText

